import { createContext } from 'react';
import { BrandsContextProps } from './interfaces/brands-context-props-interface';

const BrandsContext = createContext<BrandsContextProps>({} as BrandsContextProps);

export default BrandsContext;
